import { render } from "./AddNewSupplierModal.vue?vue&type=template&id=7bb0b136&scoped=true"
import script from "./AddNewSupplierModal.vue?vue&type=script&lang=js"
export * from "./AddNewSupplierModal.vue?vue&type=script&lang=js"

import "./AddNewSupplierModal.vue?vue&type=style&index=0&id=7bb0b136&lang=scss&scoped=true"
import "./AddNewSupplierModal.vue?vue&type=style&index=1&id=7bb0b136&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb0b136"]])

export default __exports__